<div [ngClass]="inline ? 'flex gap-8' : ''">
  @for (option of options; track option.inputId) {
    <div [ngClass]="inline ? 'flex items-center' : 'flex'">
      <p-radioButton
        [inputId]="option.inputId + '_' + for"
        [value]="option.value"
        [(ngModel)]="selectedValue"
        [name]="option.name"
        (onClick)="onClick($event)"
      ></p-radioButton>
      <app-typography
        [for]="option.inputId + '_' + for"
        component="label"
        variant="smallBody"
        class="ml-2"
        >{{ option.label }}</app-typography
      >
    </div>
  }
</div>
